<template>
  <div class="add-purchase" v-if="courseDetail">
    <!--(v-if='有值')-->
    <div class="add-purchase__container">
      <navigation-bread />
      <div class="add-purchase__container__tip" v-if="headerTips">{{ headerTips }}</div>
      <course-detail
          v-if="courseDetail"
          :courseDetail="courseDetail"
          :courseInfoModule="courseDetail.courseInfoModule"
          :priceModule="courseDetail.priceModule"
         />
      <dis-content v-if="discountContent" :data="discountContent" />
      <!-- 面包屑 -->
      <div class="shift">
        <div class="shift__breadcrumb bottom-border">
          <span class="shift__breadcrumb__all">全部结果</span>
          <template v-if="addPurchaseBread && Object.keys(addPurchaseBread).length > 0">
            <i class="before"></i>
            <div
              class="shift__breadcrumb__alreayFilter"
              v-for="(value, key, index) of addPurchaseBread"
              :key="index"
            >
              <p class="shift__breadcrumb__breadcrumbItem">
                <span class="color-r middle">{{ filterName[key] }}：</span>
                <span class="color-r middle">{{ value.name }}</span>
                <span class="close-img middle" @click.prevent="closeItem(key, $event)">
                </span>
              </p>
              <i class="before"></i>
            </div>
            <div class="shift__breadcrumb__clean" @click="cleanAll($event)">清空筛选</div>
          </template>
        </div>
        <div
          class="siftMore"
          v-if="addPurchaseSift && Object.keys(addPurchaseSift).length > 3"
        >
          <span class="siftMore__text" @click="showMore">{{
            isShowAll ? '收起筛选' : '更多筛选'
          }}</span>
          <img
            src="//res11.xesimg.com/www/img/arrow-down.png"
            :class="{ rotate: isShowAll === true }"
          />
        </div>
      </div>
      <!-- 筛选项 -->
      <condition-filter :isShowMore="isShowAll"></condition-filter>
      <div ref="courseList" class="courseList">
        <div v-show="courseList && courseList.length < 1 && noMoreData" class="no-course">
          <img
            class="no-course__img"
            src="//res11.xesimg.com/x5mall/img/none_record.png"
            alt=""
          />
          <p class="no-course__text">对不起，当前时段暂时没有课程</p>
        </div>
        <div>
          <div style="min-height: 500px;" class="course-list">
            <course-card
              v-for="(item, index) in courseList"
              :key="index"
              :index="index"
              keyName="xeslog-coursecenter-coursecard"
              :data="item"
              :currentCourseId="currentCourseId"
              @handleChange="chooseCourse"
            />
          </div>
          <div class="course__bottom" ref="courseBottom">
            <div class="container">
              <div class="add-purchase__bottom__sum">合计：</div>
              <div class="add-purchase__bottom__num">¥{{ totalPrice }}</div>
              <div
                class="add-purchase__bottom__shopping-cart"
                @click="goShoppingCart($event, 'cartBallOne')"
                v-if="Number(showCartButton) === 1"
              >
                <div class="btn__text">加入购物车</div>
                <div
                  class="btn__tips"
                  v-if="courseDetail && courseDetail.cartModule.cartButtonPromotionText"
                >
                  <p class="btn__tips__linel"></p>
                  <p class="btn__tips__text">
                    {{ courseDetail && courseDetail.cartModule.cartButtonPromotionText }}
                  </p>
                  <p class="btn__tips__liner"></p>
                </div>
                <div class="btn__ball" ref="cartBallOne"></div>
              </div>
              <div
                class="add-purchase__bottom__btn"
                :class="{ 'add-purchase__bottom--disable': isDisabled }"
                @click="goPurchase($event)"
              >
                {{ courseDetail && courseDetail.buttonModule.desc }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="add-purchase__bottom" v-show="!scrollLoading"> -->
    <div class="add-purchase__bottom" v-if="!isAppear">
      <div class="container">
        <div class="add-purchase__bottom__sum">合计：</div>
        <div class="add-purchase__bottom__num">¥{{ totalPrice }}</div>
        <div
          class="add-purchase__bottom__shopping-cart"
          @click="goShoppingCart($event, 'cartBallTwo')"
          v-if="Number(showCartButton) === 1"
        >
          <div class="btn__text">加入购物车</div>
          <div
            class="btn__tips"
            v-if="courseDetail && courseDetail.cartModule.cartButtonPromotionText"
          >
            <p class="btn__tips__linel"></p>
            <p class="btn__tips__text">
              {{ courseDetail && courseDetail.cartModule.cartButtonPromotionText }}
            </p>
            <p class="btn__tips__liner"></p>
          </div>
          <div class="btn__ball" ref="cartBallTwo"></div>
        </div>
        <div
          class="add-purchase__bottom__btn"
          :class="{ 'add-purchase__bottom--disable': isDisabled }"
          @click="goPurchase($event)"
        >
          {{ courseDetail && courseDetail.buttonModule.desc }}
        </div>
      </div>
    </div>
    <div v-if="openShoppingToast" class="alert__dialog__toast">
      {{ addCartResult.title }}
    </div>
    <alert-dialog
      :data="dialogData"
      v-if="dialogData"
      @handleCleanData="cleanDialogData"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import types from './store/types'
import courseDetailTypes from '@/views/NewCourseDetail/store/types'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/observable/fromEvent'
import 'rxjs/add/operator/debounceTime'
import assPurchaseComponents from './components'
import ballAnimation from '@/util/ballAnimation'
import AlertDialog from '@/components/AlertDialog'
import { buyStatus } from '@/defines'

export default {
  name: 'AddPurchase',
  mixins: [ballAnimation],
  data() {
    return {
      scrollObservable: null,
      scrollLoading: false,
      mode: null,
      showDiffcultRecommend: false,
      pagination: 100,
      isAppear: false, // courseBtm 是否显示
      currentCourseId: undefined, // 选中的课程ID
      currentTotalPrice: null,
      currentClassId: undefined,
      inScrollBottom: true,
      openShoppingToast: false,
      dialogData: null,
      isShowAll: false,
      incPurchase: null
    }
  },
  components: {
    ...assPurchaseComponents,
    AlertDialog
  },
  async mounted() {
    if (this.userIsLogin) {
      await this.asyncFetchData()
    }
    this.scrollObservable = Observable.fromEvent(window, 'scroll')
      .debounceTime(1000 / 60)
      .subscribe(() => {
        this.scrollLoad()
      })
    // courseBottom 显示时，说明没有更多课程了，再判断是否到courseList底部，浮动bottom消失
    this.checkBottomBuy()
  },
  watch: {
    $route() {
      this.checkBottomBuy()
      this.courseExposure()
    }
  },
  computed: {
    ...mapState({
      courseDetail: state => state.AddPurchase.courseDetail,
      // incPurchase: state => state.CourseDetail.incPurchase, // 加价购
      courseList: state => state.AddPurchase.addPurchaseCourseList, // 筛选课程列表
      PagenationCount: state => state.AddPurchase.PagenationCount, // 筛选课程列表页数
      addPurchaseBread: state => state.AddPurchase.addPurchaseBread,
      filterName: state => state.AddPurchase.filterName,
      userIsLogin: state => state.userIsLogin,
      noMoreData: state => state.AddPurchase.noMoreData,
      checkCourseResult: state => state.AddPurchase.checkCourseResult,
      addCartResult: state => state.NewCourseDetail.addCartResult,
      headerTips: state =>
        state.AddPurchase.addpurchaseInfos &&
        state.AddPurchase.addpurchaseInfos.headerTips,
      discountContent: state =>
        state.AddPurchase.addpurchaseInfos &&
        state.AddPurchase.addpurchaseInfos.discountContent,
      discountPrice: state =>
        state.AddPurchase.addpurchaseInfos &&
        state.AddPurchase.addpurchaseInfos.discountContent,
      showCartButton: state =>
        state.AddPurchase.addpurchaseInfos &&
        state.AddPurchase.addpurchaseInfos.showCartButton,
      cartCount: state => state.CourseDetail.cartCount,
      addPurchaseSift: state => state.AddPurchase.addPurchaseSift
    }),
    totalPrice() {
      if (this.currentTotalPrice) {
        return this.currentTotalPrice
      } else if (this.courseDetail && this.courseDetail.priceModule.resale) {
        return this.courseDetail.priceModule.resale
      }
      return this.currentTotalPrice
    },
    // 按钮不是立即购买、诊断后报名、无资格报名、付定金、提前诊断的置灰
    isDisabled() {
      return !(
        this.courseDetail.buttonModule.id === buyStatus.immediatelyBuy ||
        this.courseDetail.buttonModule.id === buyStatus.diagnose ||
        Number(this.courseDetail.buttonModule.id) === buyStatus.payDeposit ||
        Number(this.courseDetail.buttonModule.id) === buyStatus.earlyDiagnose ||
        Number(this.courseDetail.buttonModule.id) === buyStatus.diagnoseReport
      )
    }
  },
  async beforeRouteUpdate(to, from, next) {
    if (this.userIsLogin) {
      await this.getAddPurchaseCourseList({ route: to })
      await this.getAddPurchaseSearchSift({ route: to })
      this.currentCourseId = undefined
      this.currentClassId = undefined
      this.currentTotalPrice = null
    } else {
      this.$router.push({
        name: 'course-detail',
        params: this.$route.params
      })
    }
    next()
  },
  created() {
    this.$on('LoginStatusCompleted', async isLogin => {
      if (isLogin) {
        await this.asyncFetchData()
      } else {
        this.$router.push({
          name: 'course-detail',
          params: this.$route.params
        })
      }
    })
  },
  methods: {
    // 方法事件
    ...mapActions({
      getCourseDetail: types.GET_COURSE_DETAIL, // 获取课程详情
      getAddPurchaseCourseList: types.GET_ADDPURCHASE_COURSE_LIST, // 获取课程列表
      getAddPurchaseSearchSift: types.GET_ADDPURCHASE_SIFT, // 获取删选信息
      getCheckCourse: types.GET_ADDPURCHASE_CHECK_COURSE, // 去支付校验
      getAddCart: courseDetailTypes.GET_NEW_ADD_CART // 购物车加车
    }),
    async asyncFetchData() {
      if (!this.scrollLoading) {
        this.scrollLoading = true
        await this.getAddPurchaseCourseList({ route: this.$route })
        this.scrollLoading = false
      }
      await this.getCourseDetail({ route: this.$route })
      this.incPurchase = this.courseDetail.additionalPurchaseModule
      await this.getAddPurchaseSearchSift({ route: this.$route })
      this.courseExposure()
    },
    // 点击去支付
    async goPurchase(event) {
      if (this.isDisabled) return
      this.xesLog('click', { type: 'xeslog-addPurchase-goPay', clickId: '1.5.1' }, event)
      await this.getCheckCourse({
        data: {
          courseId: String(this.courseDetail.courseInfoModule.courseId),
          classId: this.courseDetail.classLeftNumModule.classId,
          extraCourseId: this.currentCourseId,
          extraClassId: this.currentClassId,
          promotionId: this.$route.query.promotionId
        },
        route: this.$route
      })
      // 诊断或提前诊断报名
      if (
        (this.courseDetail.buttonModule.id === buyStatus.earlyDiagnose ||
          this.courseDetail.buttonModule.id === buyStatus.diagnose) &&
        this.courseDetail.examModule.examPath
      ) {
        // 考试页
        window.location.href = this.courseDetail.examModule.examPath
        return
      }
      // 查看诊断报告
      if (
        this.courseDetail.buttonModule.id === buyStatus.diagnoseReport &&
        this.courseDetail.examModule.examPath
      ) {
        this.xesLog(
          'click',
          {
            type: 'xeslog-scanReport',
            clickId: '1.3.36',
            courseid: this.courseDetail.courseInfoModule.courseId
          },
          { target: event.target }
        )
        window.open(this.courseDetail.examModule.examPath)
      }
      // 异常状态弹窗
      if (Number(this.checkCourseResult.isCanBuy) === 0) {
        let url = ''
        if (this.checkCourseResult.url) {
          url = this.checkCourseResult.url
        } else {
          url = 'https://i.xueersi.com/study/MyCourses/index#/'
        }
        this.dialogData = {
          openDialog: true,
          title: this.checkCourseResult.title,
          content: this.checkCourseResult.content,
          text: this.checkCourseResult.description,
          url: url
        }
        return
      }
      window.location.href = `https://trade.xueersi.com/Web/Order/confirm?idEncode=${this.checkCourseResult.idEncode}`
    },
    courseExposure(event) {
      const list = this.courseList.map((item, index) => {
        return {
          promotcourseid: item.id,
          promotorderid: index + 1,
          btnstate: item.saleStatus.reason
        }
      })
      this.xesLog(
        'exposure',
        {
          clickId: '1.5.3',
          type: `xeslog-addPurchase-courseListExposure`,
          content: list
        },
        { target: this.$refs.courseList }
      )
    },
    chooseCourse(data) {
      this.currentCourseId =
        this.currentCourseId === data.courseId ? undefined : data.courseId
      this.currentClassId =
        this.currentClassId === data.classId ? undefined : data.classId
      this.currentTotalPrice = this.currentCourseId
        ? data.totalPrice
        : this.courseDetail.price.resale
    },
    async scrollLoad() {
      const innerHeight = Math.ceil(window.innerHeight)
      const scrollY = Math.ceil(window.scrollY)
      const scrollHeight = document.body.scrollHeight
      // 滑动时判断是否到courseList底部，浮动bottom消失
      this.checkBottomBuy()
      if (this.scrollLoading) return
      if (scrollHeight < scrollY + innerHeight + 300) {
        // 300
        // 到达底部 加载更多
        this.scrollLoading = true
        this.getCourses()
      }
    },
    closeItem(item, event) {
      const oldQuery = this.$route.query
      let newQuery = this.deleteQuery(oldQuery, item) // 将关闭的项从链接中删除
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: newQuery
      })
      const clickIdTypes = {
        grades: '1.5.11',
        subjects: '1.5.12',
        difficulties: ' 1.5.13',
        terms: '1.5.14',
        timeTypes: '1.5.15',
        timeSlots: '1.5.16'
      }
      const itemClickId = clickIdTypes[item]
      this.xesLog(
        'click',
        { clickId: itemClickId, type: `xeslog-addPurchase-close-${item}` },
        event
      )
    },
    // 清除筛选条件
    async cleanAll(event) {
      const newQuery = {}
      newQuery.promotionId = this.$route.query.promotionId
      newQuery.ruleId = this.$route.query.ruleId
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: { ...newQuery, ...this.$route.params }
      })
      this.xesLog(
        'click',
        { clickId: '1.5.4', type: `xeslog-addPurchase-closeAll` },
        event
      )
    },
    async getCourses() {
      await this.getAddPurchaseCourseList({ route: this.$route, isLoadMore: true })
      this.scrollLoading = false
      this.courseExposure()
    },
    deleteQuery(oldQuery, keyName) {
      const newObj = {}
      for (let key in oldQuery) {
        if (key !== keyName) {
          newObj[key] = oldQuery[key]
        }
      }
      return newObj
    },
    dealBreadFilItem() {
      if (this.breadFilItem) {
        const newObj = {}
        for (let key in this.breadFilItem) {
          newObj[key] = this.breadFilItem[key].id
        }
        return newObj
      }
      return null
    },
    checkBottomBuy() {
      if (this.$refs.courseBottom) {
        // courseBottom 显示时，说明没有更多课程了，再判断是否到courseList底部，浮动bottom消失
        const innerHeight = Math.ceil(window.innerHeight)
        const scrollY = Math.ceil(window.scrollY)
        const el = this.$refs.courseBottom
        let offsetTop = el.offsetTop
        let offsetButtom = scrollY + innerHeight - offsetTop
        // console.log('==offsetButtom===', scrollY, innerHeight, offsetTop, offsetButtom)
        this.isAppear = offsetButtom > 200
      }
    },
    // 加入购物车
    async goShoppingCart(event, ball) {
      let productCourse = [
        {
          productId: this.courseDetail.courseInfoModule.courseId,
          classId: this.courseDetail.classLeftNumModule.classId,
          parentProductId: 0,
          promotionId: this.incPurchase ? this.incPurchase.promotionId : 0,
          promotionType: this.incPurchase ? this.incPurchase.subType : 0
        }
      ]
      if (this.currentCourseId) {
        const addCourse = {
          productId: this.currentCourseId,
          classId: this.currentClassId || 0,
          parentProductId: this.courseDetail.id,
          promotionId: this.incPurchase ? this.incPurchase.promotionId : 0,
          promotionType: this.incPurchase ? this.incPurchase.subType : 0
        }
        productCourse.push(addCourse)
      }
      await this.getAddCart(productCourse)
      if (Number(this.addCartResult.status) !== 0) {
        if (Number(this.addCartResult.type) === 3) {
          this.openShoppingToast = true
          setTimeout(() => {
            this.openShoppingToast = false
          }, 1500)
        } else {
          let url = ''
          if (Number(this.addCartResult.type) === 1) {
            url = `https://trade.xueersi.com/shopCartWeb/#/cart`
          } else {
            url = `https://i.xueersi.com/study/MyCourses/index#/`
          }
          this.dialogData = {
            openDialog: true,
            title: this.addCartResult.title,
            content: this.addCartResult.content,
            text: Number(this.addCartResult.type) === 1 ? '查看购物车' : '查看课程',
            url: url
          }
        }
      } else {
        await this.addCartAni(ball)
        this.dialogData = {
          openDialog: true,
          title: this.addCartResult.title,
          content: this.addCartResult.content,
          text: '查看购物车',
          url: `https://trade.xueersi.com/shopCartWeb/#/cart`
        }
      }
      this.xesLog(
        'click',
        {
          clickId: '1.5.18',
          type: 'xeslog-addPurchase-addshoppingcart',
          shoppingcarcount: this.cartCount
        },
        event
      )
    },
    cleanDialogData() {
      this.dialogData = null
    },
    xesLog(
      eventName,
      { type = '', clickId = '', item = '', content = '', shoppingcarcount = '' },
      event
    ) {
      const XESLog = new this.$XESLog({
        key: type,
        clickid: clickId,
        gradeid: this.courseDetail.courseInfoModule.grades
          ? this.courseDetail.courseInfoModule.grades
              .filter(i => i===item)
              .map(_item => _item.id)
              .join(',')
          : '',
        subjectid: this.courseDetail.courseInfoModule.subjectIds,
        courseid: this.$route.params.courseId,
        promocourseid: this.currentCourseId ? this.currentCourseId : '',
        promotionid: this.$route.query.promotionId,
        promotprise: this.courseDetail.additionalPurchaseModule.discountPrice,
        totalPrice: this.currentTotalPrice ? this.currentTotalPrice : this.totalprice,
        content: content,
        difficultid: this.courseDetail.courseInfoModule.difficulty && this.courseDetail.courseInfoModule.difficulty.id,
        teacherid:
          this.courseDetail.teacherModule.chineseTeacher &&
          this.courseDetail.teacherModule.chineseTeacher[0] &&
          this.courseDetail.teacherModule.chineseTeacher[0].id,
        // counselorid: this.courseDetail.class && this.courseDetail.class.counselorId,
        shoppingcarcount: shoppingcarcount
      })
      XESLog.push({ eventname: eventName, target: event.target }, this.$route)
    },
    showMore() {
      this.isShowAll = !this.isShowAll
    }
  },
  beforeDestroy() {
    if (this.scrollObservable) this.scrollObservable.unsubscribe()
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
@import './asset/index.scss';
.router-view {
  min-height: 0px;
}
.course-list {
  margin-right: -4.5px;
  margin-left: -4.5px;
  margin-bottom: 8px;
}
.siftMore {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 77px;
  height: 22px;
  color: #999999;
  font-size: 12px;
  border: solid 1px #cccccc;
  cursor: pointer;
  padding: 0 8px;
  box-sizing: border-box;
  span {
    display: inline-block;
    vertical-align: middle;
    line-height: 20px;
  }
  img {
    display: inline-block;
    margin-left: 3px;
    vertical-align: middle;
    width: 8px;
    height: 5px;
    transition: all 0.2s;
  }
  .rotate {
    transform: rotate(180deg);
  }
}
.show-more-btn {
  position: relative;
  height: 22px;
}
</style>



// WEBPACK FOOTER //
// ./src/views/AddPurchase/index.vue